<template>
  <div>
    <base-modal :showing="visible" @close="$emit('close')" @opened="onOpened">
      <base-card
        title="Detail Pengiriman"
        :with-style="false"
        description="Detail pengiriman ekspedisi"
      >
        <div class="border-t pt-5">
          <datatable
            :columns="[
              { id: 'code', name: 'Kode Pengiriman' },
              { id: 'weight', name: 'Berat' },
              { id: 'status', name: 'Status', theadClass: 'text-center' },
              { id: 'actions', name: 'Aksi', theadClass: 'text-center' },
            ]"
          >
            <template #tbody="{ classes }">
              <tr
                v-for="(stockMovement, index) in stockMovements.data"
                :key="stockMovement.id"
              >
                <td :class="classes.td">
                  <span class="font-bold text-gray-900">{{
                    stockMovement.attributes.code
                  }}</span>
                </td>
                <td :class="classes.td">
                  {{ stockMovement.attributes.grand_total_weight | toFixed }}
                </td>
                <td :class="[classes.td, 'text-center']">
                  <base-badge
                    :color="
                      stockMovement.attributes.picked_up ? 'green' : 'yellow'
                    "
                    :class="
                      stockMovement.attributes.picked_up ? '' : 'cursor-pointer'
                    "
                    @click="onSend(stockMovement, index)"
                    >{{
                      stockMovement.attributes.picked_up
                        ? 'Dikirim'
                        : 'Belum Dikirim'
                    }}</base-badge
                  >
                </td>
                <td :class="[classes.td, 'text-center']">
                  <base-button size="sm" @click="onPrint(stockMovement)">Print</base-button>
                </td>
              </tr>
            </template>
          </datatable>
        </div>
      </base-card>
    </base-modal>
    
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :preview-modal="true"
      :enable-download="false"
      :paginate-elements-by-height="5000"
      filename="order.data.attributes.origin_code"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="210mm"
      ref="html2Pdf"
    >
      <div class="html2pdf__page" slot="pdf-content">
        <section class="html2pdf__page-break px-4 pt-1 space-y-2 text-sm">
          <table class="w-full">
            <tr>
              <td>Dikirim via</td>
              <td>:</td>
              <td>{{ printStockMovement.attributes.expedition_name }}</td>
            </tr>
            <tr>
              <td>Tanggal Jam cetak</td>
              <td>:</td>
              <td>{{ Date.now() | formatDate }}</td>
            </tr>
            <tr>
              <td>No Faktur</td>
              <td>:</td>
              <td>{{ printStockMovement.attributes.order_code }}</td>
            </tr>
            <tr>
              <td>Tujuan pengiriman</td>
              <td>:</td>
              <td>{{ printStockMovement.attributes.destination_office_code }}</td>
            </tr>
            <tr>
              <td>Jumlah total Koli</td>
              <td>:</td>
              <td>{{ printStockMovement.attributes.packets?.length | toCurrency }}</td>
            </tr>
            <tr>
              <td>Jumlah total Berat</td>
              <td>:</td>
              <td>{{ printStockMovement.attributes.grand_total_weight | toFixed }}</td>
            </tr>
          </table>
        </section>
      </div>
    </vue-html2pdf>

    <loading v-if="loading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { requestMixin } from '../../mixins/request/request';
import BaseModal from '../base/BaseModal.vue';
import VueHtml2pdf from 'vue-html2pdf';

export default {
  mixins: [requestMixin],
  components: {
    BaseModal,
    VueHtml2pdf
  },
  props: {
    visible: Boolean,
    officeExpeditionId: String,
  },
  emits: ['close', 'completed'],
  data() {
    return {
      loading: false,
      stockMovements: {
        data: [],
      },
      printStockMovement: {
        attributes: {}
      }
    };
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async onOpened() {
      this.loading = true;

      const [res, err] = await this.request(
        `/api/v1/office-expeditions/${this.officeExpeditionId}/stock-movements`,
        {
          params: {
            'filter[available_for_pickup]': true,
            'fields[stock-movements]': 'code,grand_total_weight,picked_up,order_code,destination_office_code,packets,expedition_name',
          },
        }
      );

      if (!err) {
        this.stockMovements = res;
      }

      this.loading = false;
    },
    async onSend(stockMovement, index) {
      if (!stockMovement.attributes.picked_up) {
        this.loading = true;

        const [, err] = await this.request(
          `/api/v1/stock-movements/${stockMovement.id}/-actions/pickup-expedition`,
          {
            method: 'patch',
          }
        );

        if (err) {
          this.createAlert({
            data: this.getRequestErrorMessage(err),
            status: 'error',
            timeout: 1000,
          });
        } else {
          this.stockMovements.data[index].attributes.picked_up = true;

          if (
            this.stockMovements.data.filter(
              (stockMovement) => !stockMovement.attributes.picked_up
            ).length < 1
          ) {
            this.$emit('completed');
          }
        }

        this.loading = false;
      }
    },
    onPrint(stockMovement) {
      this.printStockMovement = stockMovement

      this.$refs.html2Pdf.generatePdf()
    }
  },
};
</script>
